import React, { useMemo } from 'react';
import { ModelContent } from 'pages/Home/ModelContent';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPurchasedModels } from 'store/actions/userData';
import { ModelContext } from 'pages/Home/ModelContext';
import { useCookies } from 'react-cookie';

const PurchasedModels = () => {
  const dispatch = useDispatch();
  const [ cookies ] = useCookies([ 'userAuth' ]);
  const token = cookies.archvision_token;
  const userDataStore = useSelector(state => state.userData);
  const userId = userDataStore.data.userId;
  const getModels = () => dispatch(getUserPurchasedModels({ token, userId }));
  const purchasedModels = useMemo(() => userDataStore.purchasedModels, [ userDataStore.purchasedModels ]);

  const contextValue = {
    getModels: getModels,
    workingData: purchasedModels,
    pageTitle: 'Purchased Models',
    sortingOptions: [ 'ascending', 'descending', 'oldest first', 'newest first' ],
    searchParam: 'categories',
    searchCategoryParam: 'search_category',
    searchSubcategoryParam: 'search_subcategory',
  };

  return <ModelContext.Provider value={contextValue}>
    <ModelContent />
  </ModelContext.Provider>;
};

export { PurchasedModels };